import { modalLayer } from '@utils'
import { DiningPersonModal } from '@pages/menu/modal'
import { storeMobx } from 'restaurant'

class DiningNumberPickController {
  async showPicker (configs?: IDiningNumConfig) {
    return await modalLayer(DiningPersonModal, {
      config: configs || storeMobx.info.diningNumberConfig
    }, 'DiningPersonModal').then(res => {
      return res
    }).catch((err) => {
      return err
    })
  }
}

export default new DiningNumberPickController()
